import { format } from 'date-fns';
const APP_CONFIG = JSON.parse(localStorage.getItem('appConfig'));
import httpHelper from '../../../../utils/httpHelper';
export const service = {
  async getDevices() {
    const endPoint = `device`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      { page: 0, size: 999999 },
      'Bearer',
    );
    return result;
  },
  async getEmployees() {
    const endPoint = `kv/employee`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      { page: 0, size: 999999 },
      'Bearer',
    );
    return result;
  },
  async getDeviceVehicleRelationsSearchAll() {
    const endPoint = 'device-vehicle-relation/searchAll';
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async getEmployeesWithSearchAll() {
    const endPoint = `kv/employee/searchAll`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      { query: '' },
      'Bearer',
    );
    return result;
  },

  async summaryReport() {
    const endPoint = `device-status/reporting/summaryReport`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async summaryReportByDeviceId(deviceId) {
    const endPoint = `device-status/reporting/summaryReportByDeviceId/${deviceId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async getDeviceVehicleRelations() {
    const endPoint = 'device-vehicle-relation';
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      { page: 0, size: 999999 },
      'Bearer',
    );
    return result;
  },
  async getEmployeeCardRelations() {
    const endpoint = 'kv/card-employee-relation';
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endpoint,
      {},
      'Bearer',
    );
    return result;
  },
  async findByTransportationWithVehicleId(vehicleId, params) {
    const endPoint = `kv/transportation/findByVehicleId/${vehicleId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params || {},
      'Bearer',
    );
    return result;
  },

  async findByTransportationWithCardId(cardId) {
    const endPoint = `kv/transportation/findById/${cardId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async findByVehicleIdAndEndDateBetween(object) {
    var beginDate = new Date(object.beginDate);
    var beginNewDate = format(beginDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");
    var endDate = new Date(object.endDate);
    var endNewDate = format(endDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");

    const relation = await service.getDeviceVehicleRelations();
    const rel = relation.data.data;

    let vehicleId = null;
    rel.forEach((relation) => {
      if (relation.device.id === object.id) {
        vehicleId = relation.vehicle.id;
      }
    });

    const endPoint = `kv/transportation/findByVehicleIdAndEndDateBetween/${vehicleId}?size=99999&page=0&t0=${beginNewDate}&t1=${endNewDate}&sort=id,desc`; //{object.id}
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async findAllTransportationsByVehicleIdAndEndDateBetween(params, id) {
    const endPoint = `kv/transportation/findAllByVehicleIdAndEndDateBetween/${id}`; //{object.id}
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
  async findCardTransportationByEmployeeIdAndEndDateBetween(object) {
    var beginDate = new Date(object.beginDate);
    var beginNewDate = format(beginDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");
    var endDate = new Date(object.endDate);
    var endNewDate = format(endDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");

    const relation = await service.getEmployeeCardRelations();
    const rel = relation.data.data;

    let cardId = null;
    rel.forEach((relation) => {
      if (relation.employee.id === object.id) {
        cardId = relation.card.id;
      }
    });

    const endPoint = `kv/transportation/findByCardIdAndEndDateBetween/${cardId}?t0=${beginNewDate}&t1=${endNewDate}`; //{object.id}
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async findByEmployeeIdAndEndDateBetween(object) {
    var beginDate = new Date(object.beginDate);
    var beginNewDate = format(beginDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");
    var endDate = new Date(object.endDate);
    var endNewDate = format(endDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");

    const endPoint = `kv/transportation/findByEmployeeIdAndEndDateBetween/${object.id}?t0=${beginNewDate}&t1=${endNewDate}`; //{object.id}
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async findByEmployeeIdAndEndDateBetweenInCardEvent(object) {
    var beginDate = new Date(object.beginDate);
    var beginNewDate = format(beginDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");
    var endDate = new Date(object.endDate);
    var endNewDate = format(endDate, "yyyy-MM-dd'T'HH:mm:ss'Z'");

    const endPoint = `kv/card-event/findByEmployeeIdAndTimeBetween/${object.id}?t0=${beginNewDate}&t1=${endNewDate}`; //{object.id}
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async findAllByMCodeAndMtId(transportationId) {
    const endPoint = `location-data/findAllByMCodeAndMtId?mCode=KV&mtId=${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async findCardEventByTransportationId(transportationId) {
    const endPoint = `kv/card-event/findByTransportationId/${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async findDeviceEventByTransportationId(transportationId) {
    const endPoint = `kv/device-event/findAllByWrdTid/${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async findMotionEventByTransportationId(transportationId) {
    const endPoint = `kv/motion-event/findByWrdTid/${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async findAllByDeviceIdAndDeviceTimeBetween(params) {
    const endPoint = 'location-data/findAllByDeviceIdAndDeviceTimeBetween';
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },

  async findAllRelationsByObserverId(observerId) {
    const endPoint = `observer-vehicle/findAllRelationsByObserverId/${observerId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async getAllDevices() {
    const endPoint = 'device';
    const params = {
      page: 0,
      size: 99999,
    };
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
  async getLocation(coordinate) {
    const endPoint = `gh/reverse?coordinate=${coordinate}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async getAllTransportationWithSearch(params) {
    const endPoint = `kv/transportation/search`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
  async getBeltSensorEventsByTransportationId(params) {
    const { id, param } = params;
    const tEndPoint = 'kv/belt-sensor-event/findAllByTransportationId/';
    const endPoint = tEndPoint + id;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      param,
      'Bearer',
    );
    return result;
  },
  async getLoadCellEventsByTransportationId(params) {
    const { id, param } = params;
    const tEndPoint = 'kv/load-cell-event/findAllByTransportationId/';
    const endPoint = tEndPoint + id;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      param,
      'Bearer',
    );
    return result;
  },
  async getTransportationReportByTransportationId(params) {
    const { transportationId, param } = params;
    const endPoint = `kv/vehicle-safety-report/getTransportationReport?transportationId=${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      param,
      'Bearer',
    );
    return result;
  },
};

export default service;
